import { Grid, Stack, Typography } from "@mui/material";
import { PurposeIcon, TargetsIcon } from "../../../@lib/icons";

function WhyUs({ translator }: any) {
  return (
    <>
      <Stack
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        mt={5}
      >
        <Typography variant="h3" mt={3}>
          {translator("landingPage.Why It Matters")}
        </Typography>
      </Stack>
      <Grid container mt={3} px={5} mb={10}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} mt={5}>
          <Typography variant="h5" sx={{ display: "flex", alignItems: "end" }}>
            <div style={{ marginRight: "8px" }}>
              {" "}
              <TargetsIcon />
            </div>{" "}
            {translator("landingPage.Targets")}
          </Typography>
          <Typography variant="h5" mt={2}>
            {translator("landingPage.Whether you’re an")}{" "}
            <span style={{ color: "#F6A000" }}>
              {translator("landingPage.Advocate, Funder, Policymaker,")}
            </span>
          </Typography>
          <Typography variant="h5">
            {" "}
            {translator("landingPage.or")}{" "}
            <span style={{ color: "#F6A000" }}>
              {" "}
              {translator("landingPage.Influencer?")}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} mt={5}>
          <Typography
            variant="h5"
            sx={{
              display: "flex",
              alignItems: "end",
              position: "relative",
              height: "48%",
            }}
          >
            <div
              style={{ marginRight: "8px", position: "absolute", zIndex: "0" }}
            >
              <PurposeIcon />
            </div>{" "}
            <div style={{ position: "relative", marginLeft: "100px" }}>
              {translator("landingPage.Purposes")}
            </div>
          </Typography>
          <Typography variant="h5" mt={2}>
            {" "}
            {/* {translator(
              "landingPage.The Niyel Tracker equips you with the knowledge you need to act decisively."
            )} */}
            {translator(
              "landingPage.The Niyel Tracker ensures you’re never caught off guard but always ready to make a difference"
            )}
          </Typography>
          <Typography variant="h5" mt={1}>
            {" "}
            {/* This online platform equips you with the knowledge you need to act decisively. */}
            {/* {translator(
              "landingPage.Our dynamic approach ensures that you’re never caught off guard, but always ready to make a difference."
            )} */}
            {translator(
              "landingPage.This online platform equips you with the knowledge you need to act decisively."
            )}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

export { WhyUs };
